(function () {
    'use strict';

    angular
        .module('app.dailySetup')
        .directive('spBook', spBook);

    spBook.$inject = ['reactDirective'];
    /* @ngInject */
    function spBook(reactDirective) {
        return reactDirective(Book);
    }
})();


